import knightsConstantRedux from "../constant";

/************Customer invoice***********/
/**
 * reset invoice
 * @returns
 */
export const resetInvoice = () => ({
  type: knightsConstantRedux.REST_INVOICE_FUND,
});
/**
 * reset invoice
 * @returns
 */
export const resetInvoiceWithoutProduct = () => ({
  type: knightsConstantRedux.REST_INVOICE_FUND_WITHOUT_PRODUCT,
});

/**
 * set draft list
 * @param {array of draft invoice} draftInvoiceList
 * @returns
 */
export const setDraftCustomerInvoiceList = (draftInvoiceList) => ({
  type: knightsConstantRedux.SET_CUSTOMER_INVOICE_LIST,
  payload: {
    draftInvoiceList: draftInvoiceList,
  },
});

/**
 * change name
 * @param {String} name
 * @returns
 */
export const setDraftInvoiceName = (name) => ({
  type: knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_NAME,
  payload: {
    name,
  },
});

/**
 * set displayed draft  Invoice
 * @param {array of draft invoice} draftInvoice
 * @returns
 */
export const setDraftCustomerInvoice = (draftInvoice) => ({
  type: knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE,
  payload: {
    draftInvoice: draftInvoice,
  },
});

/**
 * set new draft Invoice
 * @param {array of draft invoice} draftInvoice
 * @returns
 */
export const setAddNewDaftCustomerInvoice = (draftInvoice) => ({
  type: knightsConstantRedux.SET_NEW_DRAFT_INVIOCE_TO_LIST,
  payload: {
    draftInvoice: draftInvoice,
  },
});
/**
 * delete draft Invoice
 * @param {array of draft invoice} draftInvoiceId
 * @returns
 */
export const deleteDraftCustomerInvoice = (draftInvoiceId) => ({
  type: knightsConstantRedux.DELETE_DRAFT_CUSTOMER_INVOICE,
  payload: {
    draftInvoiceId: draftInvoiceId,
  },
});
/**
 * set draft Invoice property
 * @param {string} property
 * @param {string} value
 * @returns
 */
export const setDraftInvoiceProperty = (property, value) => ({
  type: knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_PROPERTY,
  payload: {
    property,
    value,
  },
});
/**
 * set draft Invoice products property
 * @param {string} property
 * @param {string} value
 * @returns
 */
export const setDraftInvoiceProductProperty = (
  id,
  property,
  value,
  priceCurrencyType
) => ({
  type: knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_PROPERTY,
  payload: {
    id,
    property,
    value,
    priceCurrencyType,
  },
});
/**
 * set draft Invoice product Discount
 * @param {string} value
 * @returns
 */
export const setDraftInvoiceProductDiscountProperty = (
  discount,
  discountType
) => ({
  type: knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_PRODUCT_DISCOUNT_PROPERTY,
  payload: {
    discount,
    discountType,
  },
});
/**
 * set draft Invoice Discount Value
 * @param {string} value
 * @returns
 */
export const setDraftInvoiceDiscountProperty = (value, LBPRate) => ({
  type: knightsConstantRedux.SET_DRAFT_CUSTOMER_INVOICE_DISCOUNT_PROPERTY,
  payload: {
    value,
    LBPRate,
  },
});
/**
 * set draft Invoice Discount property
 * @param {string} value
 * @returns
 */
export const setDraftInvoicePaidPrice = (price, priceType, type, exchange) => ({
  type: knightsConstantRedux.SET_DRAFT_CUTOMER_INVOICE_PAID_PRICE,
  payload: {
    price,
    priceType,
    type,
    exchange,
  },
});
/**
 * set draft Invoice Discount property
 * @param {string} discountType
 * @returns
 */
export const setDraftInvoiceDiscountType = (discountType) => ({
  type: knightsConstantRedux.SET_DRAFT_CUTOMER_INVOICE_DISCOUNT_TYPE,
  payload: {
    discountType,
  },
});
/**
 * reset draft invoice
 * @returns
 */
export const resetDraftCustomerInvoice = (id) => ({
  type: knightsConstantRedux.RESET_DRAFT_CUSTOMER_INVOICE,
  payload: {
    id,
  },
});
/**
 * delete draft invoice
 * @param {object} product
 * @returns
 */
export const deleteDraftInvoiceProduct = (product) => ({
  type: knightsConstantRedux.DELETE_DRAFT_INVOICE_PRODUCT,
  payload: {
    product,
  },
});
/**
 * add draft invoice
 * @param {object} product
 * @returns
 */
export const addDraftInvoiceProduct = (product) => ({
  type: knightsConstantRedux.ADD_DRAFT_INVOICE_PRODUCT,
  payload: {
    product,
  },
});

/*************App Setting***********/

/**
 * edit main price
 * @param {number} mainPrice
 * @returns
 */
export const editMainPrice = (mainPrice) => ({
  type: knightsConstantRedux.EDIT_MAIN_PRICE,
  payload: {
    mainPrice,
  },
});
export const editCommision = (commission) => ({
  type: knightsConstantRedux.EDIT_COMMISSION,
  payload: {
    commission,
  },
});

/**
 * edit main currency
 * @param {object} mainCurrency
 * @returns
 */
export const editMainCurrency = (mainCurrency) => ({
  type: knightsConstantRedux.EDIT_MAIN_CURRENCY,
  payload: {
    mainCurrency,
  },
});
/**
 * edit edit currency in coin
 * @param {object} editCurrency
 * @returns
 */
export const editCoins = (editCurrency) => ({
  type: knightsConstantRedux.EDIT_COINS,
  payload: {
    editCurrency,
  },
});
/**
 * delete currency in coin
 * @param {object} deleteCurrency
 * @returns
 */
export const deleteCoins = (deleteCurrency) => ({
  type: knightsConstantRedux.DELETE_COINS,
  payload: {
    deleteCurrency,
  },
});
/**
 * set currency in coin
 * @param {object} coinsList
 * @returns
 */
export const setCoinList = (coinsList) => ({
  type: knightsConstantRedux.SET_COINS_LIST,
  payload: {
    coinsList,
  },
});
/**
 * add currency to coin
 * @param {object} currency
 * @returns
 */
export const addCoinsItem = (currency) => ({
  type: knightsConstantRedux.ADD_COINS_ITEM,
  payload: {
    currency,
  },
});
/**
 * edit productField
 * @param {object} productField
 * @returns
 */
export const editProductFields = (productField) => ({
  type: knightsConstantRedux.EDIT_PRODUCT_FIELDS,
  payload: {
    productField,
  },
});
/**
 * edit productField
 * @param {object} productField
 * @returns
 */
export const changeProductFieldsPosition = (
  productFieldBefore,
  productFieldAfter
) => ({
  type: knightsConstantRedux.CHANGE_PRODUCT_POSITION,
  payload: {
    productFieldBefore,
    productFieldAfter,
  },
});

/**
 * set productFields
 * @param {object} productFields
 * @returns
 */
export const setProductFields = (productFields) => ({
  type: knightsConstantRedux.SET_PRODUCT_FIELDS,
  payload: {
    productFields,
  },
});

/**
 * set pos features
 * @param {object} posFeatures 
 * @returns 
 */
export const setPosFeatures = (posFeatures) => ({
  type: knightsConstantRedux.SET_POS_FEATURES,
  payload: {
    posFeatures,
  },
});

export const setPricingConfig = (config) => ({
  type: knightsConstantRedux.SET_PRICING_CONFIG,
  payload: {
    pricing_mode: config.pricing_mode,
    profit_type: config.profit_type,
    default_min_profit_pct: config.default_min_profit_pct,
    default_max_profit_pct: config.default_max_profit_pct,
    default_sale_type: config.default_sale_type,
  },
});
/**
 * set service list
 * @param {list} serviceList
 * @returns
 */
export const setServiceList = (serviceList) => ({
  type: knightsConstantRedux.SET_SERVICE_LIST,
  payload: {
    serviceList,
  },
});

/**
 * edit service
 * @param {object} service
 * @returns
 */
export const editService = (service) => ({
  type: knightsConstantRedux.EDIT_SERVICE,
  payload: {
    service,
  },
});

/**
 * add service
 * @param {object} service
 * @returns
 */
export const addService = (service) => ({
  type: knightsConstantRedux.ADD_TO_SERVICE_LIST,
  payload: {
    service,
  },
});
/**
 * setUserPermissionsList
 * @param {object} permission
 * @returns
 */
export const setUserPermissions = (permission, user, sessionTime) => ({
  type: knightsConstantRedux.SET_PERMISSIONS,
  payload: {
    permission,
    user,
    sessionTime,
  },
});
/**
 * set user logged in
 * @param {object} user
 * @param {object} sessionTime
 * @returns
 */
export const setUserLoggedIn = (user, sessionTime) => ({
  type: knightsConstantRedux.SET_USER_LOGIN,
  payload: {
    user,
    sessionTime,
  },
});
/**
 * user logged OUT
 * @returns
 */
export const userLogOut = () => ({
  type: knightsConstantRedux.SET_USER_LOGOUT,
});
export const setAccessToken = (token) => ({
  type: knightsConstantRedux.SET_ACCESS_TOKEN,
  payload: { accessToken: token },
});
export const clearAccessToken = () => ({
  type: knightsConstantRedux.CLEAR_ACCESS_TOKEN,
});
/**
 * user update property
 * @returns
 */
export const updateUserProperty = (property, value) => ({
  type: knightsConstantRedux.UPDATE_USER_PROPERTY,
  payload: {
    property,
    value,
  },
});

export const editDelimiter = (value) => ({
  type: knightsConstantRedux.EDIT_DELIMITER,
  payload: {
    value,
  },
});
export const addBarCodeField = (value) => ({
  type: knightsConstantRedux.ADD_BARCODE_FIELD,
  payload: {
    value,
  },
});
export const deleteBarcodeField = (value) => ({
  type: knightsConstantRedux.DELETE_BARCODE_FIELD,
  payload: {
    value,
  },
});

/**
 * set charge type list
 * @param {object} chargesList
 * @returns
 */
export const setChargesTypeList = (chargesTypeList) => ({
  type: knightsConstantRedux.SET_CHARGES_TYPE_LIST,
  payload: {
    chargesTypeList,
  },
});
/**
 * set expire period
 * @param {Number} expirePeriod
 * @returns
 */
export const setExpirePeriod = (expirePeriod) => ({
  type: knightsConstantRedux.EDIT_EXPIRE_PERIOD,
  payload: {
    expirePeriod,
  },
});
/**
 * add charge type
 * @param {object} chargesType
 * @returns
 */
export const addChargesType = (chargesType) => ({
  type: knightsConstantRedux.ADD_CHARGE_TYPE,
  payload: {
    chargesType,
  },
});
/**
 * edit charge type
 * @param {object} chargesType
 * @returns
 */
export const editChargesType = (chargesType) => ({
  type: knightsConstantRedux.EDIT_CHARGE_TYPE,
  payload: {
    chargesType,
  },
});
/**
 * edit lira transfer
 * @param {Integer} liraRound
 * @returns
 */
export const setliraRound = (liraRound) => ({
  type: knightsConstantRedux.EDIT_lira_round,
  payload: {
    liraRound,
  },
});
/**
 * delete charge type
 * @param {object} chargesType
 * @returns
 */
export const deleteChargesType = (chargesType) => ({
  type: knightsConstantRedux.DELETE_CHARGE_TYPE,
  payload: {
    chargesType,
  },
});
/**
 * Get main currency
 * @returns
 */
export const getMainCurrency = () => ({
  type: knightsConstantRedux.GET_MAIN_CURRENCY,
});

/**
 * Update Lang
 * @param {string} lang
 * @returns
 */
export const updateLang = (lang, dir) => ({
  type: knightsConstantRedux.UPDATE_LANG,
  payload: {
    lang,
    dir,
  },
});

/**
 * add department to departmentList
 * @param {Object} department
 * @returns
 */
export const setDepartmentItem = (department) => ({
  type: knightsConstantRedux.SET_DEPARTMENT_LISTS,
  payload: {
    department,
  },
});

/**
 * add department to departmentList
 * @param {Object} department
 * @returns
 */
export const setDepartmentList = (departmentList) => ({
  type: knightsConstantRedux.SET_DEPARTMENT_LISTS,
  payload: {
    departmentList,
  },
});

/**
 * set fund open
 * @param {Boolean} openFund
 * @param {Number} boxId
 * @returns
 */
export const setOpenFund = (fundOpen, boxId) => ({
  type: knightsConstantRedux.SET_FUND_OPEN,
  payload: {
    fundOpen,
    boxId,
  },
});

/**
 * set view settings (card dimensions)
 * @param {Object} viewSettings
 * @returns
 */
export const setViewSettings = (viewSettings) => ({
  type: knightsConstantRedux.SET_VIEW_SETTINGS,
  payload: {
    viewSettings,
  },
});

/**
 * set integration config
 * @param {Object} integrationConfig 
 * @returns 
 */
export const setIntegrationConfig = (integrationConfig) => ({
  type: knightsConstantRedux.SET_INTEGRATION_CONFIG,
  payload: {
    integrationConfig,
  },
});

/**
 * set invoice templates list
 * @param {Array} invoiceTemplates
 * @returns
 */
export const setInvoiceTemplates = (invoiceTemplates) => ({
  type: knightsConstantRedux.SET_INVOICE_TEMPLATES,
  payload: {
    invoiceTemplates,
  },
});

/**
 * add invoice template
 * @param {Object} invoiceTemplate
 * @returns
 */
export const addInvoiceTemplate = (invoiceTemplate) => ({
  type: knightsConstantRedux.ADD_INVOICE_TEMPLATE,
  payload: {
    invoiceTemplate,
  },
});

/**
 * update invoice template
 * @param {Object} invoiceTemplate
 * @returns
 */
export const updateInvoiceTemplate = (invoiceTemplate) => ({
  type: knightsConstantRedux.UPDATE_INVOICE_TEMPLATE,
  payload: {
    invoiceTemplate,
  },
});

/**
 * delete invoice template
 * @param {Number} templateId
 * @returns
 */
export const deleteInvoiceTemplate = (templateId) => ({
  type: knightsConstantRedux.DELETE_INVOICE_TEMPLATE,
  payload: {
    templateId,
  },
});

/**
 * set current invoice template
 * @param {Object} currentTemplate
 * @returns
 */
export const setCurrentInvoiceTemplate = (currentTemplate) => ({
  type: knightsConstantRedux.SET_CURRENT_INVOICE_TEMPLATE,
  payload: {
    currentTemplate,
  },
});
